import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';
import { genericGridAccessor } from 'ps-components/AdvancedTable/GenericGrid/GenericGridFunctions';
import { CommentRender, PricingDetails, PricingDetailsSubRow } from './JobPricingCellRender';
import React from 'react';
import { PRICING_TYPE } from '../../../SkillGeoDifferential/SkillGeoDifferentialReducer';
import { HIDDEN_TERMS, ModifyAdj, ModifyAging, ModifyGeo, ModifyWgt } from './JobPricingGridCreate';
import { formatDate } from 'ps-components/AdvancedTable/GenericGrid/GenericGridCellRenderers';

const CompensationSummaryMatchDetails = (rowData, key, options) => {
  const effDate =
    rowData.field_pub_survey_effective_date ||
    rowData.effective_date_default ||
    rowData.pub_survey_effective_date_default;
  const matchId = rowData.field_match_id;
  const commentRender = CommentRender(matchId, rowData, options);
  return (
    <>
      <span className="extra-details-container">
        {`${rowData.field_total_companies || rowData.total_companies_default || '-'} cos,
          ${rowData.field_total_incumbents || rowData.total_incumbents_default || '-'} ees,
          ${rowData.field_currency || rowData.currency_default || 'currency'}, eff ${formatDate(effDate)}`}
      </span>
      <div className="default-cell__comment">{rowData.data_adjustment_factor_reason_default && commentRender}</div>
    </>
  );
};

const newGenericGrid = new GenericGridCreator(
  'COMPENSATION_SUMMARY_REPORT',
  {},
  {
    surveysForSlottedMatches: {},
    slottedDetailsLoading: [],
    slottedExpandedSections: {},
    uncheckingParticipationIDs: [],
    checkingParticipationIDs: [],
    selectedCutIDs: [],
    defaultLeftColumns: [
      {
        Header: data => {
          return data.options.pricingType === PRICING_TYPE.SLOTTED ? 'Slotted Job Match' : 'Survey Job Match';
        },
        id: 'match',
        stickyLeft: true,
        customRender: (rowData, key, options) => {
          options.customMatchDetailsRenderer = CompensationSummaryMatchDetails;
          if (options.meta.isSubRow) {
            return PricingDetailsSubRow(rowData, key, options);
          }

          return PricingDetails(rowData, key, options);
        },
        width: 200,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'job_title'),
        centerAlign: false,
        leftAlign: true,
        onTop: 2,
        minWidth: 200,
        maxWidth: 200,
        getClassName: options => {
          return options.meta.isSubRow ? 'sub-row-custom-render' : '';
        }
      },
      {
        Header: 'Aging',
        id: 'aging-column',
        stickyLeft: true,
        customRender: ModifyAging,
        width: 50,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'aging_factor'),
        centerAlign: true,
        maxWidth: 50
      },
      {
        Header: 'Adj',
        id: 'adj-column',
        stickyLeft: true,
        customRender: ModifyAdj,
        width: 35,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'data_adjustment_factor'),
        centerAlign: true,
        onTop: 1,
        maxWidth: 35
      },
      {
        Header: 'Geo',
        id: 'geo-column',
        stickyLeft: true,
        customRender: ModifyGeo,
        width: 35,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'geo_adj_factor'),
        centerAlign: true,
        maxWidth: 35
      },
      {
        Header: 'Wgt',
        id: 'wgt-column',
        stickyLeft: true,
        customRender: ModifyWgt,
        width: 35,
        accessTerms: true,
        accessor: terms => genericGridAccessor(terms, 'data_weighting_factor'),
        centerAlign: true,
        maxWidth: 35
      }
    ],
    termsColumnWidthOverride: 50,
    hiddenTerms: HIDDEN_TERMS
  },
  {
    getInstanceState: store => store.marketPricing.JobPricingReducer.CompensationSummaryGridReducer
  }
);
export const compensationSummaryJobPricingGridActions = newGenericGrid.getActions();

const reducer = newGenericGrid.createReducer();

export default reducer;
